/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * @TODO: Rename to CameraType or VideoSourceType
 */ 
export enum DeviceType {
    Standard = 0,
    Epiphan = 1,
    PTZCamera = 2,
    ZoomCamera = 3,
    InputVideoEncoder = 7,
    HdmiEncoderTbs = 8,
    /**
     * Used for unit tests
     */ 
    VlcServer = 9,
    /**
     * Used for testing any device that provides H264 over RTSP on some URL
     */ 
    GenericRTSP = 10,
    DriftCam = 11,
    FileStream = 12,
    HdmiTbsMulti = 13,
}
